<script setup>

import { defineProps} from "vue";
import UtilMoney from "../../../../utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pagamentoEletronico"
]);

//==================================================================//
//=================== Linhas do Pagamento Header ===================//
//==================================================================//

let linhasDoPagamentoHeaders = [
    { text: 'Código do Pagamento',       value: 'pagamentoCodigo',              class:"c-parcelas__header",   cellClass:'c-parcelas__cell',   width:"88px"},
    { text: 'Status',                    value: 'status',                       class:"c-parcelas__header",   cellClass:'c-parcelas__cell',   width:"180px"},
    { text: 'Filial',                    value: 'filial.codigo',                class:"c-parcelas__header",   cellClass:'c-parcelas__cell',   width:"180px"},
    { text: 'Colaborador',               value: 'pagadorColaborador.nome',      class:"c-parcelas__header",   cellClass:'c-parcelas__cell',   width:"180px"},
    { text: 'Pensionista',               value: 'favorecidoPensionista.nome',   class:"c-parcelas__header",   cellClass:'c-parcelas__cell',   width:"180px"},
    { text: 'Data Pagamento Prevista',   value: 'dataPagamentoPrevista',        class:"c-parcelas__header",   cellClass:'c-parcelas__cell',   width:"180px"},
    { text: 'Data Pagamento Efetiva',    value: 'dataPagamentoEfetiva',         class:"c-parcelas__header",   cellClass:'c-parcelas__cell',   width:"180px"},
    { text: 'Valor Pagamento',           value: 'valorPagamento',               class:"c-parcelas__header",   cellClass:'c-parcelas__cell',   width:"180px"},
]

</script>

<template>

    <v-card
        class="c-linhas-do-pagamento"
    >

        <v-card-title
            class="c-linhas-do-pagamento__titulo"
        >
        
            <h3>Linhas do Pagamento</h3>

        </v-card-title>

        <div
            class="c-linhas-do-pagamento__conteudo"
        >

            <v-data-table
                class="c-linhas-do-pagamento__tabela elevation-1"
                :headers="linhasDoPagamentoHeaders"
                :items="props?.pagamentoEletronico?.linhasDoPagamento"
                :items-per-page="-1"
                item-key="id"
            >

                <template v-slot:item.valorPagamento="{ item }">

                    R$ {{UtilMoney.toBRL(item?.valorPagamento)}}

                </template>

            </v-data-table>

        </div>

    </v-card>


</template>

<style scoped>

.c-campo{
    pointer-events: none;
}

.c-linhas-do-pagamento__tabela{
    display: grid;
    white-space: nowrap;
}

</style>